import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'utcMoment',
     
})
export class UTCMomentPipe implements PipeTransform {
  transform(value): any {
    if (!value) {
      return null;
    }

    return moment.utc(value);
  }
}
